import request from '@/utils/request'

// 获取商机列表
export function getOpportunityList(data) {
  return request({
    url: '/move/getBusinessList',
    method: 'post',
    data
  })
}

export function addActivities(data) {
  return request({
    url: '/move/addActivities',
    method: 'post',
    data
  })
}

// 添加商机
export function addOpportunity(data) {
  return request({
    url: '/move/addBusiness',
    method: 'post',
    data
  })
}

// 更新商机
export function updateOpportunity(data) {
  return request({
    url: '/move/editBusiness',
    method: 'post',
    data
  })
}

// 删除商机
export function deleteOpportunity(id) {
  return request({
    url: `/opportunity/${id}`,
    method: 'delete'
  })
} 

export function getExportOffer(data) {
  return request({
    url: `/export/getExportOffer`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}   